// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgSortAz24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_6772_360314)">
					<path d="M21.6456 15.0296L21.5613 14.9583C21.2631 14.7378 20.8351 14.7637 20.5627 15.0296L18.8054 16.7869V7.40384C18.8054 6.98235 18.4618 6.63867 18.0403 6.63867C17.6188 6.63867 17.2751 6.98235 17.2751 7.40384V16.7804L15.5178 15.0231C15.2195 14.7248 14.7332 14.7248 14.4349 15.0231C14.1366 15.3214 14.1366 15.8077 14.4349 16.106L17.4956 19.1667C17.7939 19.465 18.2802 19.465 18.5785 19.1667L21.6392 16.106C21.9374 15.8077 21.9374 15.3214 21.6392 15.0231L21.6456 15.0296Z" />
					<path d="M7.06855 5.3999L5 11.2165H6.54979L6.95831 9.97146H9.07874L9.49375 11.2165H11.0306L8.9685 5.3999H7.06855ZM7.30199 8.92746L7.98935 6.83946H8.04122L8.72858 8.92746H7.29551H7.30199Z" />
					<path d="M5.2854 13.8361H8.50819L5.2854 18.077V18.9265H10.4665V17.7203H7.25668L10.4665 13.4795V12.6235H5.2854V13.8361Z" />
				</g>
				<defs>
					<clipPath id="clip0_6772_360314">
						<rect width={16.8726} height={14} transform="translate(5 5.3999)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgSortAz24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgSortAz24;
